// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as React from "react";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as SecurityCodeVerification from "../../../library/SecurityCodeVerification.bs.js";

var nestedInput = Curry._1(BsCss.style, {
      hd: BsCss.selector("input", {
            hd: BsCss.lineHeight(BsCss.px(50)),
            tl: {
              hd: BsCss.color(Theme.Color.charcoal),
              tl: {
                hd: BsCss.borderRadius(BsCss.px(6)),
                tl: {
                  hd: BsCss.width(BsCss.px(36)),
                  tl: {
                    hd: BsCss.height(BsCss.px(42)),
                    tl: {
                      hd: BsCss.boxSizing("borderBox"),
                      tl: {
                        hd: BsCss.fontSize(BsCss.px(32)),
                        tl: {
                          hd: BsCss.margin(BsCss.px(4)),
                          tl: {
                            hd: BsCss.borderWidth(BsCss.px(1)),
                            tl: {
                              hd: BsCss.borderStyle("solid"),
                              tl: {
                                hd: BsCss.borderColor(Theme.Color.lightGrey),
                                tl: {
                                  hd: BsCss.boxShadow(Css_Legacy_Core.Shadow.box(BsCss.px(0), BsCss.px(0), BsCss.px(10), undefined, undefined, Css.rgba(0, 0, 0, BsCss.pct(10.0)))),
                                  tl: {
                                    hd: BsCss.paddingTop(BsCss.px(5)),
                                    tl: {
                                      hd: BsCss.textAlign("center"),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }),
      tl: /* [] */0
    });

var Styles = {
  nestedInput: nestedInput
};

var make = React.memo(function (props) {
      var segmentData = props.segmentData;
      var purchaseCallback = props.purchaseCallback;
      var signupType = props.signupType;
      var state = props.state;
      var state_firstName = state.firstName;
      var state_lastName = state.lastName;
      var state_email = state.email;
      var state_password = state.password;
      var state_phoneNumber = state.phoneNumber;
      var state_marketingOptIn = state.marketingOptIn;
      var state$1 = {
        firstName: state_firstName,
        lastName: state_lastName,
        email: state_email,
        password: state_password,
        phoneNumber: state_phoneNumber,
        marketingOptIn: state_marketingOptIn
      };
      if (purchaseCallback !== undefined) {
        if (segmentData !== undefined) {
          return JsxRuntime.jsx(SecurityCodeVerification.make, {
                      state: state$1,
                      signupType: signupType,
                      purchaseCallback: purchaseCallback,
                      segmentData: segmentData
                    });
        } else {
          return JsxRuntime.jsx(SecurityCodeVerification.make, {
                      state: state$1,
                      signupType: signupType,
                      purchaseCallback: purchaseCallback
                    });
        }
      } else if (segmentData !== undefined) {
        return JsxRuntime.jsx(SecurityCodeVerification.make, {
                    state: state$1,
                    signupType: signupType,
                    segmentData: segmentData
                  });
      } else {
        return JsxRuntime.jsx(SecurityCodeVerification.make, {
                    state: state$1,
                    signupType: signupType
                  });
      }
    });

export {
  Styles ,
  make ,
}
/* nestedInput Not a pure module */
